/**
 * Layout 布局组件
 * 通过监听路由变化，同步 PC 侧边栏和移动端 Tabbar 的高亮状态
 */
export default {
  name: 'LayoutPage',
  data() {
    return {
      active: 0
    };
  },
  computed: {
    // 当前激活路由，用于 PC 侧边栏高亮
    activeRoute() {
      return this.$route.path;
    }
  },
  watch: {
    // 路由变化时同步移动端 tabbar 索引
    '$route.path': {
      handler(path) {
        const map = {
          '/layout/home': 0,
          '/layout/hot': 1,
          '/layout/search': 2
        };
        this.active = map[path] ?? 0;
      },
      immediate: true
    }
  }
};